'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tlds = require('tlds');

var _tlds2 = _interopRequireDefault(_tlds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reusables
var validTlds = _tlds2.default.concat(['local', 'dev']).join('|'); /* eslint no-useless-escape: [0] */
// https://github.com/lukechilds/my-name-is-url

var escapeChar = '\\';
var notWhitespaceCommaDoubleQuoteOrDot = '[^' + escapeChar + 's"]';
var dot = escapeChar + '.';
var hostnameChars = '[a-z0-9]';
var number = '[0-9]';
var endingChars = dot + '?([' + escapeChar + 's<>",]|$)';

// Sections
var optionalScheme = '(?:(?:ht|f)tps?:\/\/)?';
var hostname = '(((' + hostnameChars + '-*)*' + hostnameChars + '+)' + dot + ')+(' + validTlds + ')';
var ip = '(' + number + '{1,3}' + dot + '){3}' + number + '{1,3}';
var optionalPortNumber = '(:' + number + '+)?';
var optionalSlash = '(' + escapeChar + '/(' + notWhitespaceCommaDoubleQuoteOrDot + '*)?)?';
var endsWithButDontMatch = '(?=' + endingChars + ')';

// Build
var regex = optionalScheme + '(localhost|' + hostname + '|' + ip + ')' + optionalPortNumber + optionalSlash + endsWithButDontMatch;

exports.default = new RegExp(regex, 'gi');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/url-regex.js
// module id = 753
// module chunks = 0